import axios from "axios";
import { Link } from "react-router-dom";
import { ViewerError } from "@/components/common";

/** Why a joint review page could not load, in the backend's words when it gave
 * them: a caller who is not one of the review's two readers gets a 403 that
 * says so. Anything but a 403 or 404 can be retried. */
export function JointReviewLoadError({ error, onRetry }: { error: unknown; onRetry: () => void }) {
  const response = axios.isAxiosError(error) ? error.response : undefined;
  const detail = (response?.data as { detail?: unknown } | undefined)?.detail;
  const title =
    response?.status === 403
      ? "You can't open this joint review"
      : response?.status === 404
        ? "This joint review doesn't exist"
        : "This joint review didn't load";
  const retryable = response?.status !== 403 && response?.status !== 404;
  return (
    <ViewerError
      title={title}
      message={typeof detail === "string" ? detail.replace(/([^.!?])$/, "$1.") : undefined}
      actions={
        <>
          <Link
            to="/labeling-overview"
            className="rounded-xs border border-border-strong px-3 py-1 text-xs text-fg-muted hover:text-fg"
          >
            ← Labeling
          </Link>
          {retryable && (
            <button
              type="button"
              onClick={onRetry}
              className="rounded-xs border border-signal bg-signal px-3 py-1 text-xs text-fg"
            >
              Try again
            </button>
          )}
        </>
      }
    />
  );
}
